import { JsonObject, JsonProperty } from 'json2typescript';
import { User } from '../users/user';


@JsonObject('Message')
export class Message {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('content', String, true)
    content: string = null;

    @JsonProperty('user', User, true)
    user: User = null;

    @JsonProperty('seen_by', [User], true)
    User: User[] = [];

    @JsonProperty('created_date', String, true)
    createdDate: string = null;
}

@JsonObject('WebSocketMessage')
export class WebSocketMessage {
    @JsonProperty('command', String, true)
    command: string = null;

    @JsonProperty('message', Message, true)
    message: Message = null;

    @JsonProperty('messages', [Message], true)
    messages: Message[] = [];

    @JsonProperty('user', String, true)
    user: string = null;

    @JsonProperty('is_typing', Boolean, true)
    isTyping: boolean = false;
}